import React from "react";
import { linkPreviewConverter } from "../link-preview-converter";
import { LinkPreviewViewer } from "../viewer/link-preview-viewer";
const LinkPreview = ({ node }) => {
  const ricosNode = React.useMemo(() => linkPreviewConverter.fromPm.convert(node.toJSON()), [node]);
  return /* @__PURE__ */ React.createElement(LinkPreviewViewer, { node: ricosNode });
};
export {
  LinkPreview
};
//# sourceMappingURL=link-preview.js.map
